import californiaImg from '../../../media/about/california/jtree_sign_group.jpeg';
import hollywood from '../../../media/about/california/Hollywood.jpeg';
import hoonigan from '../../../media/about/california/Hoonigan.jpeg';
import abOrange from '../../../media/about/california/ab_orange.jpeg';
import angelesNp from '../../../media/about/california/angeles_np.jpeg';
import angelsStadium from '../../../media/about/california/angels_stadium.jpeg';
import bigBear from '../../../media/about/california/big_bear.jpeg';
import chuckwalla from '../../../media/about/california/chuckwalla.png';
import danaPoint from '../../../media/about/california/dana_point.jpeg';
import davenport from '../../../media/about/california/davenport_bay_area.jpeg';
import griffith from '../../../media/about/california/griffith.jpeg';
import jimMiller from '../../../media/about/california/jim_miller.jpeg';
import jtreeAlyab from '../../../media/about/california/jtree_alyab.jpeg';
import juliaSanDiego from '../../../media/about/california/julia_san_diego.jpeg';
import roomateGrove from '../../../media/about/california/roomate_grove.jpeg';
import sanDiego from '../../../media/about/california/san_diego.jpeg';
import santaClara from '../../../media/about/california/santa_clara_rainbow.jpeg';
import sdsu from '../../../media/about/california/sdsu.jpeg';
import juliaGrove from '../../../media/about/california/julia_grove.jpeg';
import hollywoodSign from '../../../media/about/california/hollywood_sign.jpg';
import hollywoodTrail from '../../../media/about/california/hollywood_trail.jpg';

const californiaStory = {
  id: "california",
  title: "California",
  heroImage: californiaImg,
  gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",

  description: `Growing up, I spent countless hours playing Grand Theft Auto V, and when it came time to choose a college, I knew I wanted to experience California firsthand. I'd always associated Los Angeles with the world of GTA V, and I was eager to explore as much as I could. California appealed to me for the climate, the landscape, the lifestyle, and the people. I've truly enjoyed my three and a half years living on the West Coast.`,

  gallery: [
    { type: 'image', src: hollywoodSign, alt: 'Julia and I at the Hollywood Sign' },
    { type: 'image', src: hollywoodTrail, alt: 'Hollywood Sign trail map' },
    { type: 'image', src: hollywood, alt: 'Hollywood Sign' },
    { type: 'image', src: hoonigan, alt: 'Hoonitron at San Clemente car show' },
    { type: 'image', src: abOrange, alt: 'Old Town Orange' },
    { type: 'image', src: angelesNp, alt: 'Angeles National Forest climbing' },
    { type: 'image', src: angelsStadium, alt: 'Angels Stadium' },
    { type: 'image', src: bigBear, alt: 'Big Bear' },
    { type: 'image', src: chuckwalla, alt: 'Chuckwalla Valley Raceway' },
    { type: 'image', src: danaPoint, alt: 'Dana Point Harbor' },
    { type: 'image', src: davenport, alt: 'Davenport Bay Area' },
    { type: 'image', src: griffith, alt: 'Griffith Observatory' },
    { type: 'image', src: jimMiller, alt: 'Chapman housing at night' },
    { type: 'image', src: jtreeAlyab, alt: 'My roommate and I at Joshua Tree' },
    { type: 'image', src: juliaSanDiego, alt: 'My girlfriend Julia in San Diego' },
    { type: 'image', src: roomateGrove, alt: 'The Grove with roommates' },
    { type: 'image', src: sanDiego, alt: 'San Diego beach' },
    { type: 'image', src: santaClara, alt: 'Santa Clara rainbow' },
    { type: 'image', src: sdsu, alt: 'SDSU campus with my mom and brother' },
    { type: 'image', src: juliaGrove, alt: 'Julia and I at the Grove in LA' }
  ]
};

export default californiaStory;
